module.exports = __webpack_public_path__ + "img/back.ecadfd49.jpeg";